import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import HomeWidgetService from "../../../services/KangarooServices/Intelligence/HomeWidgetService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const HomeWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ HomeWidgetForm ~ selectedItem:", selectedItem);
  const [institutedata, setInstituteData] = useState([]);
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;

  const [loading, setLoading] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const fetchWidgetData = async (page = 1, size = 1000) => {
    try {
      const response = await WidgetService.getList({
        isOnshore: isOnshorePage,
        page,
        pageSize: size,
      });
      setWidgetData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchWidgetData();
  }, []);

  const widgetTypeData = [
    { value: 1, label: "Home" },
    { value: 2, label: "TestPreperation" },
    { value: 3, label: "Travel" },
    { value: 4, label: "OSHC" },
    { value: 5, label: "VisaMigration" },
    { value: 6, label: "TaxReturn" },
    { value: 7, label: "KevsFeesAndCharges" },
    { value: 8, label: "Education" },
  ];
  const instituteOptions = widgetTypeData.map((i) => ({
    value: i.value,
    label: i.label,
  }));
  const getWidgetPageTypeValue = (label) => {
    return widgetTypeData.find((item) => item.label === label)?.value || null;
  };
  const formik = useFormik({
    initialValues: {
      orderIndex: selectedItem?.orderIndex,
      widgetPageType: selectedItem?.widgetPageType
        ? getWidgetPageTypeValue(selectedItem.widgetPageType)
        : null,
      widgetId: selectedItem?.widget?.id || null,
      isOnshore:
        selectedItem?.isOnshore !== undefined
          ? selectedItem.isOnshore
          : isOnshoreAdmin,
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        // Build payload

        if (selectedItem?.id) {
          await HomeWidgetService.update(selectedItem?.id, values);
          toast.success("Form updated successfully");
        } else {
          await HomeWidgetService.create(values);
          toast.success("Form created successfully");
        }
        resetForm();
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await DestinationService.getList();
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversityData();
  }, []);

  const widgetOptions = widgetData?.map((type) => ({
    value: type.id,
    label: type.name,
  }));
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Pages Widget</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {isSuperAdmin && (
            <div className="mb-3">
              <Label>Intelligence Display</Label>
              <select
                name="isOnshore"
                className="form-select"
                value={String(formik.values.isOnshore)}
                onChange={(e) =>
                  formik.setFieldValue("isOnshore", e.target.value === "true")
                }
              >
                <option value="true">Onshore Intel Menu</option>
                <option value="false">Offshore Intel Menu</option>
              </select>
            </div>
          )}
          <div className="mb-3">
            <Label htmlFor="name">Order Index</Label>
            <Input
              id="orderIndex"
              name="orderIndex"
              type="number"
              value={formik.values.orderIndex}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.orderIndex && !!formik.errors.orderIndex}
            />
            {formik.touched.orderIndex && formik.errors.orderIndex && (
              <FormFeedback>{formik.errors.orderIndex}</FormFeedback>
            )}
          </div>
          <div className="mb-3">
            <Label>Widget Page Type</Label>
            <Select
              options={widgetTypeData}
              value={
                widgetTypeData.find(
                  (opt) => opt.value === formik.values.widgetPageType,
                ) || null
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetPageType",
                  selected ? selected.value : null,
                )
              }
              placeholder="Select page type"
            />
          </div>
          <div className="mb-3">
            <Label>Widget</Label>

            <Select
              options={widgetOptions}
              value={
                widgetOptions.find(
                  (option) => option.value === formik.values.widgetId,
                ) || null
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetId",
                  selected ? selected.value : null,
                )
              }
              placeholder="Select widget"
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default HomeWidgetForm;
